import api from "../../api/organisation.api";

const state = {
	listings: [],
	isFetching: false,
	errorMessage: null
};

const getters = {
	list: (state) => state.listings,
	error: (state): string => state.errorMessage as string,
	fetching: (state): boolean => state.isFetching as boolean,
	mappedListings: (state) =>
		state.listings.map((listing) => ({
			id: listing.id,
			name: listing.title + " (" + listing.postcode + ")"
		}))
};

const actions = {
	async fetch({ commit }, organisationid) {
		commit("LOAD_START");
		const _listings = await api.listings(organisationid);
		commit(`SET_LISTINGS`, _listings);
		commit(`LOAD_FINISH`);
	}
};

const mutations = {
	LOAD_START(state: any) {
		state.errorMessage = null;
		state.isFetching = true;
	},
	LOAD_FINISH(state: any) {
		state.errorMessage = null;
		state.isFetching = false;
	},
	SET_LISTINGS(state: any, listings) {
		state.listings = listings;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
